const coverageBuildingsQuery = `[{
    "coverageCode": $coverageCodeBuildings,
    "deductibleAmount": $deductibleAmount,
    "insuredFamilyComposition": $insuredFamilyComposition
}]`;

export default coverageBuildingsQuery;
